import * as scenes from '@/scenes'
import { watch } from '@/store'

const IDLE = 0
const STARTED = 1
const STOPPED = 2
const PAUSED = 3

/**
 * The Manager handles individual scenes.
 */
export default class Manager {
  state = IDLE
  stage = null
  scene = null
  scenes = []

  constructor (stage) {
    this.stage = stage

    this.scenes = [
      new scenes.BeachScene(stage),
      new scenes.CityScene(stage),
      new scenes.CountryScene(stage),
      new scenes.EndScene(stage),
      new scenes.ForestScene(stage),
      new scenes.HospitalScene(stage),
      new scenes.IntroScene(stage),
      new scenes.ParkScene(stage),
      new scenes.SelectCharacterScene(stage),
      new scenes.SelectPlayerScene(stage),
      new scenes.SelectStoryScene(stage),
      new scenes.StartScene(stage)
    ]

    watch('scene', async name => {
      await this.stop()
      this.start(name)
    })

    watch('paused', isPaused => {
      if (this.state === STOPPED) return
      isPaused ? this.pause() : this.resume()
    })
  }

  start (name) {
    this.state = STARTED
    this.scene = this.scenes.find(scene => scene.name === name)
    this.scene && this.scene.start()
  }

  stop () {
    this.state = STOPPED

    if (this.scene) {
      return this.stage.fadeOut()
        .then(() => this.scene.stop())
    }

    return Promise.resolve()
  }

  pause () {
    this.state = PAUSED
    this.scene && this.scene.pause()
  }

  resume () {
    this.state = STARTED
    this.scene && this.scene.resume()
  }

  update () {
    this.scene && this.scene.update()
  }
}
